/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FilterType, SidepanelConfiguration} from "../../../../data/finders.model";
import Block from "../../../atoms/layout/Block";
import {ShowHide} from "../../../atoms/layout/ShowHide";
import {TagList, TagListItem} from "../../../molecules/finder/TagList";
import {TagType} from "../../../../data/aem.model";
import {connect} from "react-redux";
import {openFinderPanel} from "../../../../actions/finder";
import {Checkbox} from "../../../atoms/forms/Checkbox";
import {makeAvailableTagSelector} from "../../../../selectors/finder";
import {withI18N} from "../../../hoc/withI18N";
import {compose} from "redux";
import {FilterContainer} from "./FilterContainer";


class _ListCheckboxesFilter extends React.Component {

    static propTypes = {
        filter: PropTypes.oneOfType([PropTypes.shape(FilterType), PropTypes.any]),
        selected: PropTypes.arrayOf(PropTypes.shape(TagType)),
        tags: PropTypes.arrayOf(PropTypes.shape(TagType)),
        toggleTag: PropTypes.func,
        sidepanel: PropTypes.shape(SidepanelConfiguration),
        expanded: PropTypes.bool,
        availableTags: PropTypes.array,
        openFinderPanel: PropTypes.func,
        collapsible: PropTypes.bool,
        children: PropTypes.any
    };

    static defaultProps = {
        filter: {},
        tags: null,
        mainTag: [],
        selected: [],
        collapsible: false
    };

    constructor(props) {
        super(props);

        this.state = {
            collapsed: false,
            loaded: false,
            open: -1
        };

        this.renderCheckedCheckboxes = this.renderCheckedCheckboxes.bind(this);
        this.availableTagsSelector = makeAvailableTagSelector((collection) => collection.tags);
    }

    componentDidMount() {
        this.handleSelectedChange();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selected !== this.props.selected) {
            this.handleSelectedChange();
        }
    }

    handleSelectedChange = () => {
        const {selected, filter, toggleTag, tags} = this.props;

        if (!this.state.loaded && selected.length > 0) {
            if (filter.tags.length === 1) {
                this.setState({loaded: true, open: 0});
            } else {
                let indexes = [];

                if (filter.tags.length > 0) {
                    selected.some(t => {
                        let index = filter.tags.indexOf(t);
                        index < 0 ? filter.tags.forEach((tag, i) => t.id.startsWith(tag.id) ? indexes.push(i) : null) : indexes.push(index);
                    });

                    indexes = [...new Set(indexes)];

                    if (indexes.length > 0) {
                        indexes.map((i, s) => (s > 0) ? toggleTag(filter.tags[i].id) : null);
                    }
                }

                this.setState({loaded: true, open: (indexes.length > 0) ? indexes[0] : -1});
            }
        } else if (!tags && selected.length === 0) {
            this.setState({open: -1});
        }
    };

    toggle = (index) => {
        this.setState({open: this.state.open === index ? -1 : index});
        this.props.filter.tags && this.props.filter.tags[index] && this.props.toggleTag(this.props.filter.tags[index].id);
    };

    renderCheckedCheckboxes({ tag, checked, onTagSelect }) {
        const { filter, openFinderPanel, sidepanel } = this.props;
        const expanded = sidepanel && sidepanel.tag === tag.id;

        if (filter.hideExtraOptions || !tag.children || tag.children.length === 0) {
            return <TagListItem tag={tag} checked={checked} onTagSelect={onTagSelect}/>
        }

        return (<Block key={tag.id} className={"filter__checkboxes-list__subcategory-selection" + (expanded ? " expanded" : "")}>
            <Checkbox id={tag.id} label={tag.title} selected={checked} onChange={() => onTagSelect(tag.id)} centered/>
            <Block className="filter__checkboxes-list__subcategory-link">
                {expanded ?
                    <p className="text-description">{filter.childTagSubtitle}</p>
                    :
                    <div className="btn-tertiary" onClick={() => openFinderPanel(filter.index, tag.id)}>
                        {filter.childTagSubtitle}
                    </div>}
            </Block>
        </Block>)
    }

    render() {
        const {filter, selected, toggleTag, tags, availableTags, collapsible} = this.props;
        const {collapsed, open} = this.state;

        if (!filter) {
            return null;
        }

        const title = filter.title || (filter.tags.length > 0 && filter.tags[0] && filter.tags[0].title) || "";

        return  <Block className={`finder__filter filter-${filter.type.toLowerCase()}`}>
            <FilterContainer filter={{...filter, title}}
                             selected={selected}
                             toggleTag={toggleTag}
                             defaultOpen={true}
                             collapsible={collapsible}>

                {filter.tags && filter.tags.filter(tag => tag).map((tag, index) => {
                    const usableTags = this.availableTagsSelector({tags: tags || tag.children, availableTags});

                    if (!usableTags || usableTags.length === 0) {
                        return null;
                    }

                    const selectedFilters = selected && selected.filter(s => s.id.startsWith(tag.id));
                    const show = (open === index);

                    if ((tags && index === 0) || !tags) {
                        return (
                            <Block key={`filter-${filter.index}-${tag.id}`}
                                   className={`finder__filter-body ${show ? "open" : "closed"}`}>
                                <ShowHide show={!collapsed}>
                                    <div className={"finder__filter-checkboxes-button" + (show ? " open" : "")}
                                            onClick={() => this.toggle(index)}>
                                        {filter.tagTitle || tag.title}
                                        <span className={`svg-arrow-${show ? "up-xs" : "down-black75-xs"}`}/>
                                    </div>
                                    <ShowHide show={show}>
                                        <TagList title={filter.subtitle}
                                                 tags={usableTags}
                                                 selected={selectedFilters}
                                                 onTagSelect={toggleTag}
                                                 collapsed={!show}
                                                 checkedItem={this.renderCheckedCheckboxes}/>
                                    </ShowHide>
                                </ShowHide>
                            </Block>
                        );
                    }
                })}

            </FilterContainer>
        </Block>
    }
}

export const ListCheckboxesFilter = compose(connect(undefined, { openFinderPanel }), withI18N)(_ListCheckboxesFilter);
